function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
export default function Icon(props) {
  const {
    fillColor,
    style,
    ...restProps
  } = props;
  const newstyle = {
    width: "auto",
    ...style
  };
  const fill = fillColor || "#000";
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, restProps, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04181 9C4.59181 9 5.04181 8.55 5.04181 8C5.04181 7.45 4.59181 7 4.04181 7C3.49181 7 3.04181 7.45 3.04181 8C3.04181 8.55 3.49181 9 4.04181 9ZM5.04181 12C5.04181 12.55 4.59181 13 4.04181 13C3.49181 13 3.04181 12.55 3.04181 12C3.04181 11.45 3.49181 11 4.04181 11C4.59181 11 5.04181 11.45 5.04181 12ZM5.04181 16C5.04181 16.55 4.59181 17 4.04181 17C3.49181 17 3.04181 16.55 3.04181 16C3.04181 15.45 3.49181 15 4.04181 15C4.59181 15 5.04181 15.45 5.04181 16ZM20.0418 13H8.04181C7.49181 13 7.04181 12.55 7.04181 12C7.04181 11.45 7.49181 11 8.04181 11H20.0418C20.5918 11 21.0418 11.45 21.0418 12C21.0418 12.55 20.5918 13 20.0418 13ZM8.04181 17H20.0418C20.5918 17 21.0418 16.55 21.0418 16C21.0418 15.45 20.5918 15 20.0418 15H8.04181C7.49181 15 7.04181 15.45 7.04181 16C7.04181 16.55 7.49181 17 8.04181 17ZM8.04181 9C7.49181 9 7.04181 8.55 7.04181 8C7.04181 7.45 7.49181 7 8.04181 7H20.0418C20.5918 7 21.0418 7.45 21.0418 8C21.0418 8.55 20.5918 9 20.0418 9H8.04181Z"
  }));
}